module.exports = __webpack_public_path__ + "img/icon-prefeitura.45bbed8b.svg";